import { connect, ConnectedProps } from "react-redux";
import { priceDropProtectionCandidateIdSelector } from "../../reducer/selectors";
import { PriceFreezeEntry } from "./component";
import { IStoreState } from "../../../../reducers/types";

const mapStateToProps = (state: IStoreState) => {
  return {
    priceDropProtectionCandidateId:
      priceDropProtectionCandidateIdSelector(state),
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PriceFreezeEntryConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedPriceFreezeEntry = connector(PriceFreezeEntry);
